import { useQuery } from '@tanstack/react-query';

import { userKeys } from '@/shared/lib/query/queryKeys';

import { getUserDetail } from '@/entities/user/api';

type UseUserDetailParams = {
  userName: string;
  enabled?: boolean;
};

export const useUserDetail = ({ userName, enabled = true }: UseUserDetailParams) => {
  return useQuery({
    queryKey: userKeys.detail(userName),
    queryFn: () => getUserDetail(userName),
    enabled: enabled && !!userName,
    staleTime: 5 * 60 * 1000,
  });
};
